/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef, useMemo } from "react";
import axios from "axios";

const Goto = (props) => {
    const _titleId = (props.match.params.TitleId !== undefined) ? props.match.params.TitleId : null;
   
    useEffect(() => {
                if (_titleId != null && _titleId != '') {
                    props.history.push({
                        pathname: '/subsignature/edit2',
                        state: {
                            titleId: _titleId
                        }
                    })
                }
            },
            error => {
                props.history.push({
                    pathname: '/auth/login-page',
                    state: {
                        redirect: '/subsignature/id/' + _titleId
                    }
                })
            }
        );  

    return (
        <div>
       
        </div>
    );

}





export default Goto;